import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PlansList from "../components/plans/PlansList";

const PlansListPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='All Plans List' />

                <PlansList />

            </MasterLayout>
        </>
    );
};

export default PlansListPage;
